(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/shared/components/pd-items-menu.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/shared/components/pd-items-menu.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _ReactRouterDOM = ReactRouterDOM,
  useLocation = _ReactRouterDOM.useLocation;
const _svs$ui$ReactItemsMen = svs.ui.ReactItemsMenu,
  ItemsMenu = _svs$ui$ReactItemsMen.ItemsMenu,
  IconItem = _svs$ui$ReactItemsMen.IconItem;
const _ReactRouterDOM2 = ReactRouterDOM,
  Link = _ReactRouterDOM2.Link;
const routes = svs.myProfile.constants.routes;
const getCustomersPreferences = svs.myProfile.react.store.pdPreferences.actions.getCustomersPreferences;
const makeParams = cAndI => {
  const c = cAndI.c,
    i = cAndI.i;
  if (!c || !i) {
    return '';
  }
  return "?c=".concat(c, "&i=").concat(i);
};

const PdItemsMenu = () => {
  const location = useLocation();
  const _ReactRedux$useSelect = ReactRedux.useSelector(state => state.playerDetails),
    cAndI = _ReactRedux$useSelect.cAndI;
  const _ReactRedux$useSelect2 = ReactRedux.useSelector(state => state.playerPreferences),
    playerPreferences = _ReactRedux$useSelect2.playerPreferences;
  const dispatch = ReactRedux.useDispatch();
  const params = makeParams(cAndI);
  const _React$useState = React.useState(() => [{
      href: routes.MY_PROFILE_NOTIFICATIONS + params,
      iconName: 'notifications',
      label: 'Spelnotifieringar',
      altHrefs: [routes.MY_PROFILE_NOTIFICATIONS]
    }, {
      href: routes.MY_PROFILE_COMMUNICATION + params,
      iconName: 'e-post',
      label: 'Kommunikation',
      altHrefs: [routes.MY_PROFILE_COMMUNICATION, routes.MY_PROFILE_COMMUNICATION_ADAPT_CONTENT]
    }]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    pages = _React$useState2[0],
    setPages = _React$useState2[1];
  React.useEffect(() => {
    dispatch(getCustomersPreferences());
  }, []);
  React.useEffect(() => {
    const isPlayerLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
    if (isPlayerLoggedIn) {
      const newPages = pages.slice();
      const findUppgifter = pages.findIndex(p => p.href === routes.MY_PROFILE_HOME);
      if (findUppgifter === -1) {
        newPages.unshift({
          href: routes.MY_PROFILE_HOME,
          iconName: 'my-settings',
          label: 'Mina\u{00A0}uppgifter',
          altHrefs: [routes.MY_PROFILE_INFORMATION, routes.MY_PROFILE_PLAYERDETAILS_CHANGE_EMAIL, routes.MY_PROFILE_PLAYERDETAILS_CONFIRM_EMAIL, routes.MY_PROFILE_PLAYERDETAILS_MISSING_EMAIL, routes.MY_PROFILE_PLAYERDETAILS_CHANGE_MOBILE, routes.MY_PROFILE_PLAYERDETAILS_CONFIRM_MOBILE, routes.MY_PROFILE_TRANSCRIPT]
        });
      }
      if ((playerPreferences === null || playerPreferences === void 0 ? void 0 : playerPreferences.showKyc) === '1') {
        const findKyc = pages.findIndex(p => p.href === routes.MY_PROFILE_KYC);
        if (findKyc === -1) {
          newPages.push({
            href: routes.MY_PROFILE_KYC,
            iconName: 'document',
            label: 'Kundkännedom',
            altHrefs: [routes.MY_PROFILE_KYC_QUESTIONS]
          });
        }
      }
      setPages(newPages);
    }
  }, [playerPreferences === null || playerPreferences === void 0 ? void 0 : playerPreferences.showKyc]);
  return React.createElement(ItemsMenu, {
    branding: "neutral",
    centered: true,
    customer: "neutral",
    useScrollFaders: true
  }, pages.map(_ref => {
    let href = _ref.href,
      iconName = _ref.iconName,
      label = _ref.label,
      altHrefs = _ref.altHrefs;
    return React.createElement(IconItem, {
      alignment: "vertical",
      Component: Link,
      gutter: 1,
      iconName: iconName,
      id: "".concat(label.toLowerCase(), "Nav"),
      isSelected: (location === null || location === void 0 ? void 0 : location.pathname) === href || (altHrefs === null || altHrefs === void 0 ? void 0 : altHrefs.includes(location === null || location === void 0 ? void 0 : location.pathname)),
      key: label,
      label: label,
      minWidth: 125,
      to: href
    });
  }));
};
svs.myProfile.react.shared.components.PdItemsMenu = PdItemsMenu;

 })(window);